import {
  Project,
  ProjectsState,
  PublishHistory,
} from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

type OldPublishHistory = Omit<
  PublishHistory,
  'isConsolidatingModels' | 'modelHistoriesById'
> & {
  modelHistory: {
    modelName: string;
    namedGraphIri: string;
  };
};

/**
 * * on {@link Project} move `modelHistory` in `publishHistory` to `modelHistoriesById`
 * * on {@link Project} add `isConsolidatingModels` to `publishHistory`
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v32 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v32Projects(prevState.projects);
  }

  return nextState;
};

const v32Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<
      string,
      Project & { publishHistory: OldPublishHistory }
    >
  ).forEach(([projectId, project]) => {
    const { modelHistory, ...publishHistory } = project.publishHistory;
    projectsById[projectId] = {
      ...project,
      publishHistory: {
        ...publishHistory,
        isConsolidatingModels: false,
        modelHistoriesById: {
          [project.targetModelId]: {
            modelName: modelHistory.modelName,
            namedGraphIri: modelHistory.namedGraphIri,
            shouldPublish: true,
          },
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
